<template>
    <div class="splash-container">
        <main
            class="splash-container"
            v-if="visible"
        >
            <div class="splash-container-content">
                <div class="container position-relative border-0 border-md-1 w-sm-100 p-5 shadow-lg">
                    <slot></slot>
                </div>
            </div>
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
            <div class="cube"></div>
        </main>

        <footer
            class="w-100 d-flex flex-column flex-md-row"
            v-if="visible"
        >
            <div class="p-5 flex-grow-1">
                <a
                    href="https://www.eqtiming.com/"
                    class="d-flex align-items-center mb-3 link-body-emphasis text-decoration-none"
                >
                    <img
                        src="@/assets/img/EQWhite.png"
                        class="footer-logo"
                    />
                </a>

                <p v-html="$tm('footer.supporttext', '', true)"></p>
            </div>

            <div
                class="flex-fill px-5 py-2 p-md-0 pb-md-3"
                v-html="$tm('contact.participants', '', true)"
            ></div>
            <div
                class="flex-fill px-5 py-2 p-md-0 pb-md-3"
                v-html="$tm('contact.organizers', '', true)"
            ></div>
            <div
                class="flex-fill px-5 py-2 p-md-0 pb-md-3"
                v-html="$tm('contact.timekeepers', '', true)"
            ></div>
        </footer>
    </div>
</template>
<script lang="ts" setup>
import { ref } from 'vue';

const props = withDefaults(
    defineProps<{
        timeBeforeContentVisible?: number;
    }>(),
    {
        timeBeforeContentVisible: 1,
    },
);

const visible = ref(false);

setTimeout(() => {
    visible.value = true;
}, props.timeBeforeContentVisible);
</script>
